import React from 'react';
import { RtsLoginDialog } from '../../components/Dialog/RtsLogin/RtsLoginDialog';
import { jsx as _jsx } from "react/jsx-runtime";
export const rtsLoginDialogMiddleware = dialogDispatch => store => next => action => {
  const state = store.getState();
  switch (action.type) {
    case 'toggle-watch-later':
    case 'toggle-show-favorite':
    case 'toggle-topic-favorite':
      {
        if (state.loginState.isLoggedIn) {
          next(action);
        } else {
          dialogDispatch({
            type: 'show-dialog',
            dialog: /*#__PURE__*/_jsx(RtsLoginDialog, {})
          });
        }
        break;
      }
    default:
      {
        next(action);
      }
  }
};